import React from 'react';
import { NavLink } from 'react-router-dom';
import loading from '../img/loading.gif';
import logo from '../img/log5.png';

const Navbar = () =>{
  
  
    return(
        <>
  {/* preloader section start */}
  {/* <div id="preloader">
    <div id="status"><img src={loading} id="preloader_image" alt="loader" />
    </div>
  </div> */}
  {/* preloader section end */}

   <header>
   <nav>
         <div class="logo">
		 <NavLink className="navbar-brand" to="/"><img src={logo} alt="logo" style={{"width":"200px", "height":"40px"}} /></NavLink>
         </div>
         <input type="checkbox" id="click" />
         <label for="click" class="menu-btn">
         <i class="fa fa-2x fa-bars"></i>
         </label>
         <ul className="nav-list">
		 <li className="nav-item">
  <NavLink activeClassName='menu_active' exact className="nav-link" to='/about'  >About</NavLink>
</li>
<li className="nav-item">
  <NavLink activeClassName='menu_active' exact className="nav-link " aria-current="page" to='/product'>Product</NavLink>
</li>
<li className="nav-item">
  <NavLink activeClassName='menu_active' exact className="nav-link" to='/gallery'>Gallery</NavLink>
</li>
<li className="nav-item">
  <NavLink activeClassName='menu_active' exact className="nav-link" to='/contact' >Contact</NavLink>
</li>

         </ul>
      </nav>
  </header>
        </>
    );
};

export default Navbar;